export default "__VITE_ASSET__Bpa7DvbT__"